export default __webpack_public_path__ + "static/hair-style-14219f350d3ee5ca9ee580d1d43d6db9.png";